var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentSynchronizationOffOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.172 5L11.248.342l1.505 1.317-2.157 2.466a8 8 0 016.352 1.588L20 3l1.329 1.495-2.975 2.644a8 8 0 01.721 8.597l-1.769-.934a6 6 0 00-.452-6.33l-8.926 7.935a6.001 6.001 0 004.632 1.567l-2.267-2.267 1.414-1.414L16.414 19l-4.707 4.707-1.414-1.414 2.316-2.316a8 8 0 01-6.181-2.237l-3.1 2.755L2 19l3.177-2.824a8 8 0 01-.24-7.932l1.765.94a6 6 0 00.002 5.635L15.42 7.07a6 6 0 00-4.612-.95l1.944 2.222-1.505 1.317L7.172 5zm2.672.016l-.008-.023L9.83 5l.015.016z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentSynchronizationOffOutline);
export default __webpack_public_path__ + "4550756dc02cfcd6d75c29be5f6b8f7d.svg";
export { ForwardRef as ReactComponent };